import React from "react";
import Header from "../components/about/header";
import { Team } from "../components/about/our-team/team";
import { Sec1 } from "../components/about/sec/sec1";
import { Sec2 } from "../components/about/sec/sec2";
import { Footer } from "../components/footer/footer";

const About = ({ setViewDiagnosis }) => {
  return (
    <div>
      <Header setViewDiagnosis={setViewDiagnosis} />
      <Sec1 />
      <div className="mt--mid"></div>
      <Sec2 />
      <Team />
      <Footer />
    </div>
  );
};

export default About;
